module.exports = __webpack_public_path__ + "img/fragment-2.bfc5b45e.svg";